import type {
    DynamicOfSalesChartAreaQueryParams,
    DynamicOfSalesChartAreaResponse,
} from "@src/types";
import { privateApiV2 } from "./client";

function buildDynamicOfSalesChartAreaQuery(params: DynamicOfSalesChartAreaQueryParams): string {
    const search = new URLSearchParams();

    search.set("merchant_product_id", params.merchant_product_id);

    if (params.city_id?.trim()) {
        search.set("city_id", params.city_id.trim());
    }

    if (params.date_from) {
        search.set("date_from", params.date_from);
    }

    if (params.date_to) {
        search.set("date_to", params.date_to);
    }

    if (params.granularity !== undefined && params.granularity !== null) {
        search.set("granularity", String(params.granularity));
    }

    return search.toString();
}

export async function getDynamicOfSalesChartAreaApi(
    params: DynamicOfSalesChartAreaQueryParams,
    signal?: AbortSignal,
): Promise<DynamicOfSalesChartAreaResponse> {
    const query = buildDynamicOfSalesChartAreaQuery(params);
    const endpoint = `/api/reporting/marts/dynamics-of-sales/dashboard/chart-area?${query}`;
    const { data } = await privateApiV2.get<DynamicOfSalesChartAreaResponse>(endpoint, {
        signal,
    });
    return data;
}
